/**
 * Toon alle def_pupils met de optie om eentje te selecteren, aanroepende component geeft een current_id door en een callback voor sluiten als waarde > 0 is er iets geselecteerd
 *
 *
 *
 * @history
 * 23 december 2024
 * Basis implementatie
 *
 */

import React from "react";

import {Popup} from "../containers/Popup";






export class PupilLibSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                init_done: false,
                def_pupils:[]


            };



    }

    componentDidMount() {
        const formData = new FormData();
        formData.append("access_id1", window.app.logboek.access_id1);
        formData.append("access_id2", window.app.logboek.access_id2);


        const requestOptions = {
            method: 'POST',
            body: formData
        };

        fetch("/get_def_pupils", requestOptions)
            .then(response => response.json())
            .then(def_pupils_json => {
                if (def_pupils_json.status == "ok") {
                    this.setState({"init_done": true,"def_pupils":def_pupils_json.data});

                } else {
                    console.log("?");
                }
            });
    }




    render() {

        return (
            <Popup  has_close_btn={true} title={"Kies een afbeelding uit de bibliotheek"} callback={() => this.props.callback(0,"")}>

                {!this.state.init_done &&
                    (
                        <p>Bezig met laden ....</p>

                    )}

                {this.state.init_done  && this.state.def_pupils.map((def_pupil, def_pupil_index) =>
                    (
                        <>
                            <a href="javascript:void(0);" onClick={() => this.props.callback(def_pupil.id, def_pupil.image_url)}><div className="pupil_select_pupil_wrapper">
                                <div className="pupil_select_pupil_img" style={{"background-image": "url('" + def_pupil.image_url + "'",
                                    "background-size": "contain"}}>
                                    {this.props.current_id == def_pupil.id &&
                                        (
                                            <img src="/digibord/assets/svgs/checked_red.svg" style={{"width":"25%"}}/>
                                        )}
                                </div>
                                <div className="pupil_select_pupil_title">{def_pupil.title}</div>
                            </div>
                            </a>
                        </>
                    )
                )}




            </Popup>
        );
    }

}

